import gql from "graphql-tag";

export const SCOPES_QUERY = gql`
  query GetScopesQuery {
    scopes
  }
`;



// WEBPACK FOOTER //
// ./src/queries/ScopesQuery/queries.ts